(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["reem-color-dots"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__reemDots) return;
    window.__reemDots = true;

    // Arata poza culorii in galeria cardului si trimite linkurile la varianta.
    window.reemShowColor = function (card, dot) {
      const mediaId = dot.dataset.mediaId;
      const variantId = dot.dataset.variantId;
      const slideshow = card.querySelector('slideshow-component');
      if (slideshow && mediaId) {
        const slides = slideshow.querySelectorAll('slideshow-slide');
        let found = false;
        slides.forEach((slide) => {
          if (slide.getAttribute('variant-image') == null) return;
          const match = slide.getAttribute('slide-id') === mediaId;
          slide.hidden = !match;
          if (match) found = true;
        });
        if (found && typeof slideshow.select === 'function') {
          try { slideshow.select({ id: mediaId }, undefined, { animate: false }); } catch (e) {}
        }
      }
      if (variantId) {
        card.querySelectorAll('a[href]').forEach((a) => {
          try {
            const url = new URL(a.href, location.origin);
            if (!url.pathname.includes('/products/')) return;
            url.searchParams.set('variant', variantId);
            a.href = url.toString();
          } catch (e) {}
        });
      }
      card.querySelectorAll('.reem-dots__dot').forEach((d) => d.classList.toggle('is-active', d === dot));
    };

    document.addEventListener('click', (event) => {
      const dot = event.target.closest('.reem-dots__dot');
      if (!dot) return;
      const card = dot.closest('product-card');
      if (!card) return;
      event.preventDefault();
      event.stopPropagation();
      window.reemShowColor(card, dot);
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["reem-delivery"] && !Shopify.designMode) return;
  try {
    (function () {
    const roots = document.querySelectorAll('.reem-delivery[data-cutoff]');
    if (!roots.length) return;

    const fmt = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Asia/Dubai',
      hour: 'numeric',
      minute: 'numeric',
      weekday: 'short',
      hour12: false,
    });

    function dubaiNow() {
      const parts = {};
      for (const p of fmt.formatToParts(new Date())) parts[p.type] = p.value;
      return { h: Number(parts.hour) % 24, m: Number(parts.minute), wd: parts.weekday };
    }

    function tick() {
      const now = dubaiNow();
      const weekend = now.wd === 'Sat' || now.wd === 'Sun';
      roots.forEach((root) => {
        const row = root.querySelector('[data-countdown-row]');
        if (!row) return;
        const cutoff = Number(root.dataset.cutoff) || 14;
        const minutesLeft = cutoff * 60 - (now.h * 60 + now.m);
        const today = row.querySelector('[data-state="today"]');
        const next = row.querySelector('[data-state="next"]');
        row.hidden = false;
        if (!weekend && minutesLeft > 0) {
          const h = Math.floor(minutesLeft / 60);
          const m = minutesLeft % 60;
          row.querySelector('[data-countdown]').textContent = h > 0 ? `${h}h ${String(m).padStart(2, '0')}m` : `${m} min`;
          today.hidden = false;
          next.hidden = true;
        } else {
          today.hidden = true;
          next.hidden = false;
        }
      });
    }

    tick();
    setInterval(tick, 30000);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["reem-size-guide"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-open^="reem-size-guide-"]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.open);
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      return;
    }
    const closer = event.target.closest('.reem-size-guide__dialog [data-close]');
    if (closer) {
      closer.closest('dialog').close();
      return;
    }
    const dialog = event.target.closest('.reem-size-guide__dialog');
    if (dialog && event.target === dialog) dialog.close();
  });
  } catch(e) { console.error(e); }
})();

})();
